import { toast } from "react-toastify";

export function toastError(message: any) {
    toast.error("Error: " + message)
}
   
export function toastSuccess(message: any){
     toast.success(message);
}

export function toastWarning(message: any) {
    toast.warning(message);
}

export function toastInfo(message: any) {
    toast.warning(message);
}